<h4>For Today</h4>

<h6>Delayed</h6>
<mat-list role="list">
  <mat-list-item role="listitem" *ngFor="let task of delayedEvent">
    <button mat-icon-button (click)="task.is_completed = !task.is_completed; updateTask(task)">
      <mat-icon [style.color]="task.is_completed ? '#039be5' : 'grey'">
        {{task.is_completed ? 'check_circle' : 'check_circle_outline'}}</mat-icon>
    </button>
    <div class="title" (click)="selectedTask = task; myTodayList = !myTodayList">
      <label *ngIf=" task.is_completed===false">
        {{task.title}}
      </label>
      <label *ngIf="task.is_completed === true">
        <del> {{task.title}}</del>
      </label>
      <br>
      <button class="projectName">
        <span>{{getProjectName(task)}}</span>
      </button>
      <!-- <button class="{{task.my_day}}" *ngIf="task.my_day">
        <mat-icon style="color: rgb(3, 155, 229);">wb_sunny</mat-icon>
        <span class="my_dayStatus-{{task.my_day}}" style="color: rgb(3, 155, 229);">My Day</span>
      </button> -->
      <button class="{{task.due_date}}">
        <mat-icon *ngIf="task.due_date">event_available</mat-icon>
        <span class="due_dateStatus-{{task.due_date}}" style="color:red;">{{task.due_date |date}}</span>
      </button>
      <!-- <button class="note">
        <mat-icon *ngIf="task.note">note</mat-icon>
        <span *ngIf="task.note" class="noteStatus-{{task.note}}">Note</span>
      </button> -->
      <!-- <button class="remind">
        <mat-icon *ngIf="task.remind">notification_important</mat-icon>
        <span *ngIf="task.remind" class="remindStatus-{{task.remind}}">Remind</span>
      </button> -->
    </div>
    <button mat-icon-button style="margin-left: auto" (click)="addMyDay(task)">
      <mat-icon>add</mat-icon>
    </button>
  </mat-list-item>
</mat-list>

<h6>Up Coming</h6>
<mat-list role="list">
  <mat-list-item role="listitem" *ngFor="let task of upComingEvent">
    <button mat-icon-button (click)="task.is_completed = !task.is_completed; updateTask(task)">
      <mat-icon [style.color]="task.is_completed ? '#039be5' : 'grey'">
        {{task.is_completed ? 'check_circle' : 'check_circle_outline'}}</mat-icon>
    </button>
    <div class="title" (click)="selectedTask = task; myTodayList = !myTodayList">
      <label *ngIf=" task.is_completed===false">
        {{task.title}}
      </label>
      <label *ngIf="task.is_completed === true">
        <del> {{task.title}}</del>
      </label>
      <br>
      <button class="projectName">
        <span>{{getProjectName(task)}}</span>
      </button>
      <button class="{{task.due_date}}">
        <mat-icon *ngIf="task.due_date">event_available</mat-icon>
        <span class="due_dateStatus-{{task.due_date}}" style="color:rgb(3, 155, 229);">{{task.due_date |date}}</span>
      </button>
    </div>
    <button mat-icon-button style="margin-left: auto" (click)="addMyDay(task)">
      <mat-icon>add</mat-icon>
    </button>
  </mat-list-item>
</mat-list>

<h6>Suggested</h6>
<mat-list role="list">
  <mat-list-item role="listitem" *ngFor="let task of suggestedEvent">
    <button mat-icon-button (click)="task.is_completed = !task.is_completed; updateTask(task)">
      <mat-icon [style.color]="task.is_completed ? '#039be5' : 'grey'">
        {{task.is_completed ? 'check_circle' : 'check_circle_outline'}}</mat-icon>
    </button>
    <div class="title" (click)="selectedTask = task; myTodayList = !myTodayList">
      <button class="taskTitle">
        <label *ngIf=" task.is_completed===false">
          {{task.title}}
        </label>
        <label *ngIf="task.is_completed === true">
          <del> {{task.title}}</del>
        </label>
      </button>
      <br>
      <button class="projectName">
        <span>{{getProjectName(task)}}</span>
      </button>
      <button class="{{task.due_date}}">
        <mat-icon *ngIf="task.due_date">event_available</mat-icon>
        <span class="due_dateStatus-{{task.due_date}}">{{task.due_date |date}}</span>
      </button>
    </div>
    <button mat-icon-button style="margin-left: auto" (click)="addMyDay(task)">
      <mat-icon>add</mat-icon>
    </button>
  </mat-list-item>
</mat-list>



// WEBPACK FOOTER //
// ./src/app/main/content/common/todo-tab/components/my-day-sidenav/my-day-sidenav.component.html